import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, toRefs, ref } from "vue";
import { useRoute } from "vue-router";
import DownFileList from "@/components/DownFileList/index.vue";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload,
    DownFileList: DownFileList
  },
  setup: function setup() {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var noticeId = route.query.noticeId;
    var downFileList = ref(null); // 详情信息

    var detail = reactive({
      title: "",
      richText: "",
      attachments: ""
    }); // 详情回显

    function getDetail(_x) {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getNoticeDetail"](id);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                Object.assign(detail, data);
                downFileList.value && downFileList.value["showList"]({
                  type: "ids",
                  value: detail.attachments
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getDetail(noticeId);
    });
    return _objectSpread(_objectSpread({}, toRefs(detail)), {}, {
      downFileList: downFileList
    });
  }
});